module.exports = __webpack_public_path__ + "img/yo-screen-3.8b372fc2.webp";